import { Bolt, Book, LifeBuoy, LogOut, Settings } from 'lucide-react';
import { useParams } from 'react-router';

import { Skeleton } from '@components/primitives';

import { NavigationDropdown } from '@components/features/Layout/Navigation/Dropdown';
import { usePlain } from '@components/features/Plain';
import { Restricted } from '@components/features/Restricted';
import { UserAvatar } from '@components/features/UserAvatar';
import { useAuth0 } from '@hooks/useAuth0';
import { useUserQuery } from '@queries/user';
import { docsHref } from '@utils/docs';

import css from './styles.module.css';

export function AccountDropdown() {
  const { teamUuid } = useParams();
  const { data: user } = useUserQuery();
  const { logout } = useAuth0();
  const { show, isReady } = usePlain();

  return (
    <NavigationDropdown
      align="end"
      trigger={
        <button className={css.trigger}>
          <UserAvatar
            className={css.avatar}
            uid={user?.id ?? 0}
            fallback={user?.name ?? ''}
          />
        </button>
      }
    >
      <NavigationDropdown.Section>
        <NavigationDropdown.Item
          icon={
            <span className={css.userAvatar}>
              <UserAvatar
                className={css.avatar}
                uid={user?.id ?? 0}
                fallback={user?.name ?? ''}
              />
            </span>
          }
          label={
            <span className={css.userName}>
              {user?.name ?? <Skeleton width={96} height={12} />}
            </span>
          }
        />
        <NavigationDropdown.Item
          icon={<LifeBuoy />}
          label="Help & Support"
          onClick={show}
          disabled={!isReady}
        />
        <NavigationDropdown.Item
          icon={<Book />}
          label="Documentation"
          to={docsHref()}
        />
        {teamUuid && (
          <NavigationDropdown.Item
            icon={<Settings />}
            label="Settings"
            to={`/${teamUuid}/settings`}
          />
        )}
      </NavigationDropdown.Section>

      <Restricted
        allow="internal"
        render={<NavigationDropdown.Section label="Internal" />}
      >
        <NavigationDropdown.Item icon={<Bolt />} label="Admin" to="/admin" />
      </Restricted>

      <NavigationDropdown.Section dimmed>
        <NavigationDropdown.Item
          icon={<LogOut />}
          label="Sign out"
          onClick={() => logout()}
        />
      </NavigationDropdown.Section>
    </NavigationDropdown>
  );
}
